export function CountTiles({total, userType}) {

    return <div className="col-xl-4 col-md-6">
            <div className="card">
            <div className="card-body">
                <div className="row align-items-center">
                <div className="col-8">
                    <h2 className="text-c-yellow f-w-600">{total}</h2>
                    <h4 className="text-muted m-b-0">Total Count</h4>
                </div>
                <div className="col-4 text-right">
                    <i className="feather fa fa-users display-4"></i>
                </div>
                </div>
            </div>
            <div className="card-footer bg-c-yellow">
                <div className="row align-items-center">
                <div className="col-9">
                    <p className="text-white m-b-0 h4">{userType}</p>
                </div>
                <div className="col-3 text-right">
                    <i className="feather icon-trending-up text-white f-16"></i>
                </div>
                </div>
            </div>
            </div>
        </div>

}